export { default as withErrorBoundary } from './withErrorBoundary';
export * from './types';
